import { setIn } from '../../utils/setIn'

export function loginReducer(state = {}, action) {
  switch (action.type) {
    case 'SET_AUTH': {
      const updatedState = setIn(state, ['auth'], {
        username: action.username,
        token: action.token,
        refreshToken: action.refreshToken,
        timestamp: Date.now(),
        roles: action.userRoles,
        terminalId: action.terminalId,
        userSettings: action.userSettings
      })

      return { ...updatedState, userTerminals: action.userTerminals }
    }

    case 'SET_NEW_TERMINAL': {
      return setIn(state, ['auth'], {
        ...state.auth,
        terminalId: action.payload.terminalId,
        roles: action.payload.userRoles
      })
    }

    case 'SET_NEW_TOKEN':
      return setIn(state, ['auth'], {
        ...state.auth,
        timestamp: Date.now(),
        token: action.token,
        refreshToken: action.refreshToken
      })

    case 'CLEAR_AUTH':
      return setIn(state, ['auth'], {
        username: null,
        token: null,
        refreshToken: null,
        timestamp: null,
        userRoles: [],
        terminalId: null,
        userSettings: null
      })

    default:
      return state
  }
}
